export const menuItems = [
  // TKP-139 / tasarım s.28 md.1–3: Şablon Yönetimi (faz 2 yapay zeka), Yol Haritaları ve Sistem Akış Kuralları menüden
  // kalktı. Rotalar yönlendirmeye çevrildi; backend ve veri yerinde. Kural motoru TKP-22'den beri ENABLE_SYSTEM_FLOW_RULES
  // ile varsayılan KAPALI (system_flow_rule_executor). Bekçi: tests/unit/guard/retired-management-screens.spec.js
  {
    id: 1,
    label: "common.library",
    isTitle: true,
  },
  {
    id: 2,
    label: "common.library",
    icon: "mdi mdi-database",
    subItems: [
      // BEGIN : Entity Pages
      {
        id: "sector",
        label: "sector.text",
        icon: "mdi mdi-alpha-s-circle",
        link: "/management/sector",
      },
      {
        id: 2.5,
        parentId: 2,
        label: "asset-group.text",
        icon: "bx-git-repo-forked",
        subItems: [
          {
            id: 3,
            label: "asset-group-category.text",
            link: "/management/asset-group-category",
            parentId: 2.5,
          },
          {
            id: 4,
            label: "asset-group.text",
            link: "/management/asset-group",
            parentId: 2.5,
          },
        ],
      },

      {
        id: "data-breach",
        label: "data-breach.text",
        subItems: [
          {
            id: "abroad-third-party",
            label: "abroad-third-party.text",
            link: "/management/abroad-third-party",
          },
          {
            id: "domestic-third-party",
            label: "domestic-third-party.text",
            link: "/management/domestic-third-party",
          },
          {
            id: "notification-type",
            label: "notification-type.text",
            link: "/management/notification-type",
          },
          {
            id: "possible-effect",
            label: "possible-effect.text",
            link: "/management/possible-effect",
          },
          {
            id: "processing-adjective",
            label: "processing-adjective.text",
            link: "/management/processing-adjective",
          },
          {
            id: "source-and-type",
            label: "source-and-type.text",
            link: "/management/source-and-type",
          },
        ],
      },

      {
        // TKP-178 md.60c: sistem kapsamı kaynak–veri eşleşmeleri
        id: "datasource-data-parent",
        label: "datasource-data.text",
        subItems: [
          {
            id: "datasource-data",
            label: "datasource-data.text",
            link: "/management/datasource-data",
          },
        ],
      },
      {
        id: "policy-parent",
        label: "policy.text",
        subItems: [
          {
            id: "policy",
            label: "policy.text",
            link: "/management/policy",
          },
          {
            id: "policy-group",
            label: "policy-group.text",
            link: "/management/policy-group",
          },
        ],
      },
      {
        id: "risk",
        label: "risk.text",
        subItems: [
          {
            id: "risk-definition",
            label: "risk.definition.text",
            link: "/management/risk-definition",
          },
          {
            id: "risk-threat-definition",
            label: "risk.threat-definition.text",
            link: "/management/risk-threat-definition",
          },
          {
            id: "risk-weakness-definition",
            label: "risk.weakness-definition.text",
            link: "/management/risk-weakness-definition",
          },
          {
            id: "risk-applied-control",
            label: "risk.applied-control.text",
            link: "/management/risk-applied-control",
          },
        ],
      },
      {
        id: "question-set",
        label: "question-set.plural",
        subItems: [
          {
            id: "question-set",
            label: "question-set.plural",
            link: "/management/question-set",
          },
          {
            id: "question",
            label: "question.text",
            link: "/management/question",
          },
        ],
      },
      {
        id: "tasks",
        label: "task-menu.text",
        subItems: [
          {
            id: "task-category",
            label: "task-menu.task-category.text",
            link: "/management/task-category",
          },
        ],
      },
      {
        id: "application",
        parentId: 2,
        label: "application.text",
        subItems: [
          {
            id: 3,
            label: "application.category.text",
            link: "/management/application-category",
            parentId: "application",
          },
        ],
      },
      {
        id: "country",
        parentId: 2,
        label: "country.text",
        subItems: [
          {
            id: 3,
            label: "country.country-safe-mapping.text",
            link: "/management/library/safe-country-map",
            parentId: "country",
          },
        ],
      },

      {
        id: "legal-document-template",
        label: "legal-document-template.text",
        subItems: [
          {
            id: "legal-document-template",
            label: "legal-document-template.text",
            link: "/management/legal-document-template",
          },
          {
            id: "legal-document-template-category",
            label: "legal-document-template-category.text",
            link: "/management/legal-document-template-category",
          },
        ],
      },
      {
        id: "report-template",
        label: "report-template.text",
        subItems: [
          {
            id: "report-template",
            label: "report-template.text",
            link: "/management/report-template",
          },
        ],
      },
      // END : Entity Pages
    ],
  },

  {
    id: 6,
    isLayout: true,
  },
  {
    id: 7,
    label: "account.text",
    isTitle: true,
  },

  {
    id: "app-panel",
    label: "common.panel",
    icon: "bx-user",
    link: "/management/account-workspace-organization",
  },

  {
    id: "role-management",
    label: "role.plural",
    icon: "bx-shield-quarter",
    link: "/management/role",
  },

  {
    id: "role-access-management",
    label: "role.access.text",
    icon: "bx-shield-quarter",
    link: "/management/role-access",
  },
  {
    id: 105,
    label: "common.system",
    isTitle: true,
  },
  {
    id: "log",
    label: "log.text",
    icon: "bx-code",
    link: "/management/log",
  },
  {
    id: "mail-log",
    label: "log.mail.text",
    icon: "mdi mdi-email-check-outline",
    link: "/management/mail-log",
  },

  {
    id: "announcement",
    label: "announcement.plural",
    icon: "bx bxs-megaphone",
    link: "/management/announcement",
  },
  {
    id: "config",
    label: "config.text",
    icon: "bx bx-cog",
    link: "/management/config",
  },
];
